import React  from 'react'
import { useNavigate,Navigate } from 'react-router-dom';
import FetshUsers from '../components/FetchUsers';
import Header from '../partials/Header';

//import Google from './components/Google';
function Personalizeauthor() {

  document.body.classList.remove('personalize');
  document.body.classList.add('personalize-author');
 

  
  const navigate = useNavigate();
const handleCheckChange =(evnt)=>{
  if(evnt==='success')
    navigate('/personalize-sections');
  }
  if (!localStorage.getItem('user-info')) {
    
    return <Navigate to="/" />
  
}else{return (
  <>
  <Header backhref="#/personalize" skiphref="#/personalize-sections" />
    <main>   
                     
        <div class="grid-container">
      <FetshUsers  samirCallback = {handleCheckChange} />
      </div>
    </main>
    </>
  );

}}

export default Personalizeauthor;

